
    import { Component, Mixins } from 'vue-property-decorator';
    import { YSlideshow, YSlide, YImage } from '@components/index';
    import { digits } from '@nodes/helpers/number';
    import Slideshow from '@rogues/Slideshow/shared/slideshow';
    
    @Component({
        components: {
            YSlideshow,
            YSlide,
            YImage,
        },
    })
    /**
     * @name Hero
     */
    export default class Hero extends Mixins(Slideshow) {
        /**
         * Show slide counter
         *
         * @param {number} index - index of slide
         * @returns {string}
         */
        slideIndex(index: number): string {
            const hasZero = this.getValue('slides').length > 9;
            return digits(`${index + 1 > 9 ? '' : '0'}${index + 1}/${hasZero ? '' : '0'}${this.getValue('slides').length}`, this.$i18n.locale);
        }
    }
